document.addEventListener('DOMContentLoaded', function () {
  const picker = document.getElementById('variant-picker');
  const productId = picker?.dataset.productId;

  const hiddenInput = document.getElementById('selected-variant-id');
  const addToCartBtn = document.querySelector('[data-submit-btn]');
  const qtyInput = document.querySelector('[data-qty-value]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const syncQtyInput = document.getElementById('quantity');

  // Read JSON safely from <script> tag
  const variantScript = document.getElementById('variant-data');
  let variants = [];
  if (variantScript) {
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (err) {
      console.error('Invalid JSON in variant-data', err);
      return;
    }
  }

  const optionsCount = parseInt(picker?.dataset.optionsCount) || 0;
  const selectedOptions = new Array(optionsCount).fill(null);
  let maxQty = 1;

  function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    return variantId ? parseInt(variantId, 10) : null;
  }

  function applyVariantOptions(variantObj) {
    if (!variantObj) return;
    variantObj.options.forEach((opt, i) => {
      selectedOptions[i] = opt;
    });
    updateUI();
    updateSelectedVariant();
  }

  function initVariantSelection() {
    const variantIdFromURL = getVariantFromURL();
    let variantToSelect = null;

    if (variantIdFromURL) {
      variantToSelect = variants.find(v => v.id === variantIdFromURL);
    }
    if (!variantToSelect) {
      variantToSelect = variants.find(v => v.available);
    }

    applyVariantOptions(variantToSelect);
  }

  function updateSelectedVariant() {
    const matchedVariant = variants.find(variant =>
      variant.options.every((opt, i) => selectedOptions[i] === opt)
    );

    if (matchedVariant) {
      if (hiddenInput) hiddenInput.value = matchedVariant.id;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", matchedVariant.id);
      window.history.replaceState({}, '', newUrl);

      updateAddToCartState(matchedVariant);
      updateQtyMaxFromVariant(matchedVariant);
      updatePriceSection(matchedVariant);

      // ---------- Thumbnail -> slide index ----------
      const variantIdStr = String(matchedVariant.id);
      const allThumbs = document.querySelectorAll('.thumb-slider .swiper-slide[data-variant-thumb-id]');
      let chosenThumb = null;
      let chosenIndex = -1;

      allThumbs.forEach((thumb) => {
        const idsAttr = thumb.getAttribute('data-variant-thumb-id') || '';
        const ids = idsAttr.split(',').map(s => s.trim()).filter(Boolean);
        if (ids.includes(variantIdStr)) {
          let idx = -1;
          const aria = thumb.getAttribute('aria-label'); // e.g. "7 / 24"
          if (aria) {
            const m = aria.match(/^\s*(\d+)\s*\/\s*\d+\s*$/);
            if (m) idx = parseInt(m[1], 10) - 1;
          }
          if (idx < 0) {
            idx = Array.prototype.indexOf.call(allThumbs, thumb);
          }
          chosenThumb = thumb;
          chosenIndex = idx;
        }
      });

      if (chosenThumb && chosenIndex >= 0) {
        try {
          if (typeof thumbSlider !== 'undefined') {
            if (typeof thumbSlider.slideToLoop === 'function') {
              thumbSlider.slideToLoop(chosenIndex);
            } else {
              thumbSlider.slideTo(chosenIndex);
            }
          }
        } catch (e) {}

        try {
          if (typeof mainSlider !== 'undefined') {
            if (typeof mainSlider.slideToLoop === 'function') {
              mainSlider.slideToLoop(chosenIndex);
            } else {
              mainSlider.slideTo(chosenIndex);
            }
          }
        } catch (e) {}

        try {
          chosenThumb.click();
        } catch (e) {}
      }
    } else {
      if (hiddenInput) hiddenInput.value = '';
      disableAddToCart();
      updateQtyMaxFromVariant(null);
    }
  }

  // Format helpers
  function formatMoney(amount) {
    return `$${(amount / 100).toFixed(2)}`;
  }

  function updatePriceSection(variant) {
    const priceWrapper = document.querySelector(`#pdp-price-wrapper-${productId}`);
    if (!priceWrapper) return;

    let html = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      html = `
        <span class="pdp__price font-bold">${formatMoney(variant.price)}</span>
        <s class="pdp__compare-price font-regular">${formatMoney(variant.compare_at_price)}</s>
        <span class="pdp__saving-badge font-bold">${discount}% Off</span>
      `;
    } else {
      html = `<span>${formatMoney(variant.price)}</span>`;
    }

    priceWrapper.innerHTML = html;
  }

  function updateAddToCartState(variant) {
    if (variant.available && addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('btn--disabled');
      addToCartBtn.textContent = addToCartBtn.getAttribute('data-default-label') || 'Add to Cart';
    } else {
      disableAddToCart();
    }
  }

  function disableAddToCart() {
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('btn--disabled');
      addToCartBtn.textContent = addToCartBtn.getAttribute('data-sold-out-label') || 'Sold Out';
    }
  }

  function updateUI() {
    if (!picker) return;
    picker.querySelectorAll('[data-value]').forEach(btn => {
      btn.classList.remove('pdp__option-value--selected');
    });

    picker.querySelectorAll('[data-options]').forEach((group, i) => {
      const selectedVal = selectedOptions[i];
      if (selectedVal) {
        const escapedVal = CSS.escape(selectedVal);
        const selectedBtn = group.querySelector(`[data-value="${escapedVal}"]`);
        if (selectedBtn) selectedBtn.classList.add('pdp__option-value--selected');
      }
    });
  }

  // Initialize variant picker if it exists
  if (picker) {
    picker.querySelectorAll('[data-options]').forEach((group, index) => {
      group.addEventListener('click', e => {
        const btn = e.target.closest('[data-value]');
        if (!btn || btn.disabled) return;
        selectedOptions[index] = btn.dataset.value;
        updateUI();
        updateSelectedVariant();
      });
    });
  }

  function updateQtyMaxFromVariant(variant) {
    if (variant && variant.available) {
      if (variant.inventory_management && typeof variant.inventory_quantity === "number") {
        // Tracking is on → limit to actual stock
        maxQty = variant.inventory_quantity;
      } else {
        // No inventory tracking → allow high max
        maxQty = 9999;
      }
    } else {
      maxQty = 1;
    }

    const currentVal = parseInt(qtyInput.value, 10) || 1;
    if (currentVal > maxQty) qtyInput.value = maxQty;
    updateQtyState();
  }

  function updateQtyState() {
    const val = parseInt(qtyInput.value, 10) || 1;
    if (qtyMinus) qtyMinus.disabled = val <= 1;
    if (qtyPlus) qtyPlus.disabled = val >= maxQty;
    if (syncQtyInput) syncQtyInput.value = val;
  }

  // *** MOVED QUANTITY INITIALIZATION OUTSIDE OF VARIANT PICKER CONDITIONAL ***
  // Initialize quantity controls (should work regardless of whether variants exist)
  if (!window.__variantQtyBound && qtyInput && qtyPlus && qtyMinus) {
    window.__variantQtyBound = true;

    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < maxQty) {
        qtyInput.value = (val + 1).toString();
        updateQtyState();
      }
    });

    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = (val - 1).toString();
        updateQtyState();
      }
    });

    qtyInput.addEventListener('input', () => {
      let val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > maxQty) val = maxQty;
      qtyInput.value = val.toString();
      updateQtyState();
    });

    // Initialize quantity state
    updateQtyState();
  }

  // Initialize the appropriate functionality
  if (picker) {
    // Has variant picker
    initVariantSelection();
  } else if (variants.length > 0) {
    // No picker but has variants (single/default variant)
    const defaultVariant = variants[0];
    if (hiddenInput) hiddenInput.value = defaultVariant.id;
    updateAddToCartState(defaultVariant);
    updateQtyMaxFromVariant(defaultVariant);
    updatePriceSection(defaultVariant);
  } else {
    // No variants at all - set a reasonable default max quantity
    maxQty = 9999;
    updateQtyState();
  }
});